import HeroSection from './HeroSection';
import AchievementsSection from './AchievementsSection';
import TournamentsGallerySection from './TournamentsGallerySection';
import RecognitionsSection from './RecognitionsSection';
import PrisonChessImpactSection from './PrisonChessImpactSection';

const Chess = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <AchievementsSection />
      <TournamentsGallerySection />
      <RecognitionsSection />
      <PrisonChessImpactSection />
    </div>
  );
};

export default Chess;
